<template>
  <div class="side-selector">
    <div class="side red"
         :class="{ 'is-selected': isRed }"
         @click="toggle()">
      Red
    </div>
    <div class="side blue"
         :class="{ 'is-selected': !isRed }"
         @click="toggle()">
      Blue
    </div>
  </div>
</template>

<script>
export default {
  name: 'sideSelector',
  props: {
    isRed: {
      type: Boolean,
    },
  },
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.side-selector {
  display: flex;
  border: solid 0.1rem #00000033;
  border-radius: 0.6rem;
  background: #ffffff33;
  box-shadow: 0 0.1rem 0.3rem #00000033;
  overflow: hidden;
  font-size: 1.2em;

  .side {
    padding: 0.5rem 1rem;
    color: #00000044;
    cursor: pointer;
    font-weight: 600;

    &.is-selected {
      background: #fff;
      color: #333;
      border-radius: 0.6rem;
      box-shadow: 0 0 0.5rem #00000066;
      animation: bounce-in .2s;

      &.red {
        background: red;
        color: #fff;
      }

      &.blue {
        background: blue;
        color: #fff;
      }
    }
  }
}

</style>
